/**
 * Отслеживает пересечения областей
 *
 * events:
 *  - intersect
 *  - first.intersect
 *  - show.intersect
 *  - top.show.intersect
 *  - bottom.show.intersect
 *  - top.hide.intersect
 *  - bottom.hide.intersect
 */

import { ViewModel as model } from './model';
import template from './template.html';
import './style.less';

import { registerComponent } from 'Utils/engine/register-component';

registerComponent('fc-intersection-watcher', { model, template });
